<template>
  <section class="boss-skill-sheet">
    <table class="unstriped boss-table">
      <thead>
        <tr>
          <th class="boss-table-head">
            コメント
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="boss-table-data">
            <textarea
              v-model="inputComment"
              :class="['boss-send-textarea', 'pega-textarea-resize-none']"
              data-test="comment"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <!-- ▼コメントを更新ボタン -->
    <div class="boss-layout boss-layout-center">
      <button
        class="boss-button boss-button-confirm pega-button"
        data-test="save"
        @click="save"
      >
        コメントを更新
      </button>
    </div>
    <!-- ▲コメントを更新ボタン -->
  </section>
</template>

<script>
export default {
  props: {
    userId: {
      type: Number,
      required: true
    },
    comment: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inputComment: this.comment
    }
  },
  computed: {
    isOverLength () {
      return this.inputComment.length > 200
    }
  },
  watch: {
    comment (val) {
      this.$set(this, 'inputComment', val)
    }
  },
  methods: {
    save () {
      this.$http.secured.put(`/scout/view/users/${this.userId}/_comment/v1`, { comment: this.inputComment })
        .then(response => {
          this.$toasted.global.success({ message: 'コメントを更新しました。' })
          this.$emit('update-comment', this.inputComment)
        })
    }
  }
}
</script>
